import {
  Box,
  Button,
  Typography,
  Grid,
  IconButton,
  Collapse,
  Divider,
} from '@mui/material'
import { getEnums } from '../../../../utils/Common'
import { BuildingStructuralTypes } from '../../../../models/Structural'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store'
import { useCallback, useState } from 'react'
import { toggleStructuralType } from '../../../../actions/structural'
import { ListShowMoreIcon } from '../../../Svgs'

const StructuralTypes = () => {
  const [isOpen, setIsOpen] = useState(true)
  const toggleIsOpen = useCallback(() => {
    setIsOpen((prev) => !prev)
  }, [])

  const dispatch = useDispatch()
  const selectedStructuralTypes = useSelector(
    (state: RootState) => state.structural.selectedStructuralTypes,
  )

  const handleItemClick = useCallback(
    (item: BuildingStructuralTypes) => {
      dispatch(toggleStructuralType({ item }))
    },
    [dispatch],
  )

  const getTitle = useCallback((type: BuildingStructuralTypes) => {
    if (
      type === BuildingStructuralTypes.Roof ||
      type === BuildingStructuralTypes.Foundation
    ) {
      return `${type}`
    }

    return `${type}s`
  }, [])

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          paddingLeft: '12px',
          paddingRight: '4px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          color='#04002E'
          sx={{
            fontSize: '13px',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          Structural Types
        </Typography>

        <IconButton
          onClick={toggleIsOpen}
          sx={{
            transition: 'transform 0.3s',
            transform: isOpen ? 'rotate(90deg)' : 'rotate(180deg)',
          }}
        >
          <ListShowMoreIcon
            sx={{
              fontSize: '14px',
              color: '#797979',
            }}
          />
        </IconButton>
      </Box>

      <Divider
        flexItem
        orientation='horizontal'
        sx={{
          backgroundColor: '#E4E4E4',
        }}
      />

      <Collapse in={isOpen} timeout='auto' unmountOnExit>
        <Box sx={{ flexGrow: 1, padding: '8px 12px' }}>
          <Grid container spacing={2} width='100%'>
            {getEnums(BuildingStructuralTypes).map(([key, value]) => {
              const isSelected = selectedStructuralTypes.includes(value)

              return (
                <Grid key={key} size={6}>
                  <Button
                    fullWidth
                    variant='contained'
                    disableElevation
                    onClick={() => handleItemClick(value)}
                    sx={{
                      borderRadius: '4px',
                      backgroundColor: '#F2F2F2',
                      display: 'flex',
                      alignItems: 'flex-start',
                      flexDirection: 'column',
                      border: isSelected
                        ? '2px solid #1705E5'
                        : '2px solid #F2F2F2',
                      padding: '4px',
                      gap: '4px',
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: '#E5F0FF',
                      },
                    }}
                  >
                    <img
                      alt=''
                      width='128px'
                      src={`/images/structural-elements/${getTitle(value)}.png`}
                    />

                    <Typography
                      sx={{
                        color: '#04002E',

                        fontSize: '13px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                        textAlign: 'start',
                      }}
                    >
                      {getTitle(value)}
                    </Typography>
                  </Button>
                </Grid>
              )
            })}
          </Grid>
        </Box>

        <Divider
          flexItem
          orientation='horizontal'
          sx={{
            backgroundColor: '#E4E4E4',
          }}
        />
      </Collapse>
    </Box>
  )
}

export default StructuralTypes
